module.exports = __webpack_public_path__ + "static/img/elearning.55cad02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/elearning.png
// module id = 312
// module chunks = 1